import React from 'react';
import { useSelector } from 'react-redux';
import { Button, Space } from '@cashfree-intl/coherent';
import { SubStepDescription } from 'containers/CheckoutJourney/screens/styled';
import {
  INTEGRATION_STATUS,
  IntegrationEvents,
} from 'containers/CheckoutJourney/util/constant';
import { sendAnalyticsData } from 'containers/ProductTour/helper';
import { makeSelectPlatform } from 'containers/CheckoutJourney/selector';
import { SubstepComponentProps } from 'containers/CheckoutJourney/types';

const TryItOut = ({ substep, updateStatus }: SubstepComponentProps) => {
  const selectedOption: string = useSelector(makeSelectPlatform());
  const platform: string = selectedOption === 'web' ? 'web site' : 'mobile app';

  const description: string =
    typeof substep.description === 'string'
      ? substep.description.replace(/\$platfrom/g, platform)
      : `Your integration is now complete. Let's verify it by opening your ${platform} in production and attempting a payment.`;

  const markAsDone = (): void => {
    updateStatus(IntegrationEvents.TRY_IT_OUT, INTEGRATION_STATUS.COMPLETED);
    sendAnalyticsData('tryItOutButtonClicked');
  };

  return (
    <Space gap={2.5} direction="column" className="mt-2">
      <SubStepDescription color="bodyLight">{description}</SubStepDescription>
      <Space>
        <Button primary onClick={markAsDone}>
          I&apos;ll do this later
        </Button>
      </Space>
    </Space>
  );
};

export { TryItOut };
